import React from 'react';
import { SimulationProvider } from './providers/SimulationProvider';
import SimulationContainer from './components/SimulationContainer';

function App() {
  return (
    <SimulationProvider>
      <SimulationContainer />
    </SimulationProvider>
  );
}

export default App;
